export class registrationForm {
  constructor() {
    $(document).ready(function () {
      $('#emailRepeat').on('paste', function (e) {
        e.preventDefault();
      });
    });
  }
}
